// extracted by mini-css-extract-plugin
var _1 = "UpgradeDisclaimer_upgradeDisclaimerContainer__CVzYZ";
export { _1 as "upgradeDisclaimerContainer" }
